import { css } from '@emotion/react';
import styled from '@emotion/styled';
import type { ComponentProps } from 'react';

import materialSymbol from 'storybookConfig/mixins/materialSymbol';
import resetButtonStyles from 'storybookConfig/mixins/resetButtonStyles';
import Input from 'storybookConfig/stories/molecules/Input';

const HEIGHT = 48;

export const SearchFormButton = styled((props: Omit<ComponentProps<'button'>, 'button'>) => (
  // The search icon is drawn in CSS, so the button needs a name of its own.
  <button aria-label="Search" {...props} type="submit" />
))`
  ${resetButtonStyles};
  padding: 16px 8px 16px 24px;
  ${materialSymbol({ name: 'search', size: '16px' })}

  ${({ theme }) => css`
    background: ${theme.color.inputBackground};
  `}
`;

export const SearchFormInput = styled(Input)`
  padding: 16px 8px 16px;

  ${({ theme }) => css`
    background: ${theme.color.inputBackground};
  `};

  /* The form draws the field's border around the button and the input together. */
  &,
  &:active,
  &:focus,
  &:not(:placeholder-shown) {
    border-color: transparent;
  }
`;

/**
 * Wraps a custom button and input to create a search form
 */
const SearchForm = styled.form`
  display: flex;
  height: ${HEIGHT}px;
  border: 1px solid ${({ theme }) => theme.color.inputBorder};
  border-radius: ${HEIGHT / 2}px;
  background: ${({ theme }) => theme.color.inputBackground};

  &:focus-within {
    border-color: ${({ theme }) => theme.color.inputBorderFocus};
  }

  ${SearchFormButton} {
    order: 1;
    height: 100%;
    border-radius: ${HEIGHT / 2}px 0 0 ${HEIGHT / 2}px;
  }

  ${SearchFormInput} {
    order: 2;
    flex-grow: 1;
    height: 100%;
    border-radius: 0 ${HEIGHT / 2}px ${HEIGHT / 2}px 0;
  }
`;

export default SearchForm;
